jQuery(document).ready(function($) {
    'use strict';

    // Banner - continuous scroll via requestAnimationFrame
    (function() {
        var el = document.querySelector('.banner-slider.swiper');
        if (!el) return;

        // Vänta en kort stund innan vi mäter bredder och startar loopen -
        // i Safari hinner annars font-swap/layout ändra bredderna precis
        // efter start, vilket syns som ett hack. (document.fonts.ready
        // kan ta flera sekunder i Safari, så vi använder en fast delay.)
        setTimeout(initBanner, 1000);

        function initBanner() {
            var wrapper = el.querySelector('.swiper-wrapper');
            var slides = Array.from(wrapper.querySelectorAll('.swiper-slide'));
            var slideCount = slides.length;

            // 1. Klona alla slides (gemensamt för båda)
            slides.forEach(function(s) { wrapper.appendChild(s.cloneNode(true)); });

            var allSlides = Array.from(wrapper.querySelectorAll('.swiper-slide'));
            var loopWidth = 0;
            var isMobile = window.innerWidth < 768;

            if (isMobile) {
                // --- DIN MOBIL-LOGIK (Dynamisk bredd för att rymma text på en rad) ---
                allSlides.forEach(function(s) {
                    s.style.width = 'auto';
                    s.style.flexShrink = '0';
                });

                // Mät den faktiska totala bredden av original-slidesen
                for (var i = 0; i < slideCount; i++) {
                    loopWidth += allSlides[i].offsetWidth;
                }
            } else {
                // --- DIN DESKTOP-LOGIK (Originalkoden du klistrade in) ---
                var slideWidth = el.offsetWidth;
                loopWidth = slideWidth * slideCount;

                Array.from(allSlides).forEach(function(s) {
                    s.style.minWidth = slideWidth + 'px';
                    s.style.width = 'auto';
                    s.style.flexShrink = '0';
                });
            }

            // 2. Sätt wrapper-inställningar baserat på uträknad loopWidth
            wrapper.style.cssText += 'display:flex;width:' + (loopWidth * 2) + 'px;transition:none;';

            var x = -loopWidth;
            var pxPerSec = 40;
            var last = performance.now();

            function tick(now) {
                var dt = Math.min(now - last, 100);
                last = now;
                x += pxPerSec * dt / 1000;

                // Sömlös loop: om x når 0, hoppa tillbaka till start av loopen
                if (x >= 0) x -= loopWidth;

                wrapper.style.transform = 'translate3d(' + x + 'px, 0, 0)';
                requestAnimationFrame(tick);
            }
            requestAnimationFrame(tick);
        }
    }());

    // Hero Swiper
    var hero_swiper = new Swiper('.hero .swiper.hero-swiper', {
        observer: true,
        observeParents: true,
        autoplay: {
            delay: 7000,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        speed: 1500,
        allowTouchMove: false,
        preloadImages: false,
        lazy: {
            checkInView: true,
            loadPrevNext: true,
        },
    });

    // Grid Swiper

    $('.grid-swiper').each(function(index) {
        var $swiperObject = $(this);
        var swiperId = 'swiper-' + index;
        var paginationId = 'pagination-' + index;
        var nextId = 'next-' + index;
        var prevId = 'prev-' + index;

        // Add data-id attributes to the elements
        $(this).find('.swiper').attr('data-id', swiperId);
        $(this).find('.swiper-pagination').attr('data-id', paginationId);
        $(this).find('.swiper-button-next').attr('data-id', nextId);
        $(this).find('.swiper-button-prev').attr('data-id', prevId);

        // Selectors using the data-id attributes
        var swiperSelector = '[data-id="' + swiperId + '"]';
        var paginationSelector = '[data-id="' + paginationId + '"]';
        var nextSelector = '[data-id="' + nextId + '"]';
        var prevSelector = '[data-id="' + prevId + '"]';

        const swiper = new Swiper(swiperSelector, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            slidesOffsetBefore: 24,
            grabCursor: true,
            speed: 700,
            pagination: {
                el: paginationSelector,
                type: 'progressbar',
            },
            navigation: {
                nextEl: nextSelector,
                prevEl: prevSelector,
            },
            breakpoints: {
                768: {
                    spaceBetween: 32,
                    slidesOffsetBefore: 48,
                },
                1024: {
                    spaceBetween: 32,
                    slidesOffsetBefore: 0,
                },
            },
            on: {
                init() {
                    var imageHeight = $swiperObject.find(
                        '.image-container:first').outerHeight() / 2;
                    $(nextSelector).css('top', imageHeight);
                    $(prevSelector).css('top', imageHeight);
                },
                resize() {
                    var imageHeight = $swiperObject.find(
                        '.image-container:first').outerHeight() / 2;
                    $(nextSelector).css('top', imageHeight);
                    $(prevSelector).css('top', imageHeight);
                },
            },
        });

    });

    // Quote Swiper

    $('.quote-swiper').each(function(index) {
        var swiperId = '.quote-swiper-' + index;
        var nextId = '.quote-next-' + index;
        var prevId = '.quote-prev-' + index;

        // Add data-id attributes to the elements
        $(this).find('.swiper').attr('data-id', swiperId);
        $(this).find('.swiper-button-next').attr('data-id', nextId);
        $(this).find('.swiper-button-prev').attr('data-id', prevId);

        // Selectors using the data-id attributes
        var swiperSelector = '[data-id="' + swiperId + '"]';
        var nextSelector = '[data-id="' + nextId + '"]';
        var prevSelector = '[data-id="' + prevId + '"]';

        const quote_swiper = new Swiper(swiperSelector, {
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            speed: 700,
            allowTouchMove: false,
            navigation: {
                nextEl: nextSelector,
                prevEl: prevSelector,
            },
        });

    });

    // Grid Item Image Swiper

    $('.grid-item-swiper').each(function(index) {
        const swiperId = '.grid-item-swiper-' + index;
        const paginationId = '.grid-item-pagination-' + index;
        const nextId = '.grid-item-swiper-next-' + index;
        const prevId = '.grid-item-swiper-prev-' + index;

        // Add data-id attributes to the elements
        $(this).find('.swiper').attr('data-id', swiperId);
        $(this).find('.swiper-pagination').attr('data-id', paginationId);
        $(this).find('.swiper-button-next').attr('data-id', nextId);
        $(this).find('.swiper-button-prev').attr('data-id', prevId);

        // Selectors using the data-id attributes
        const swiperSelector = '[data-id="' + swiperId + '"]';
        const paginationSelector = '[data-id="' + paginationId + '"]';
        const nextSelector = '[data-id="' + nextId + '"]';
        const prevSelector = '[data-id="' + prevId + '"]';

        const grid_item_swiper = new Swiper(swiperSelector, {
            watchSlidesVisibility: true,
            preloadImages: false,
            lazy: true,
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            speed: 700,
            allowTouchMove: true,
            pagination: {
                el: paginationSelector,
            },
            navigation: {
                nextEl: nextSelector,
                prevEl: prevSelector,
            },
        });
    });

    // Image gallery

    var image_swiper = new Swiper('.image-slider.swiper', {
        grabCursor: true,
        speed: 700,
        pagination: {
            el: '.image-slider .swiper-pagination',
            type: 'fraction',
        },
        navigation: {
            nextEl: '.image-slider .swiper-button-next',
            prevEl: '.image-slider .swiper-button-prev',
        },
    });

    // Guide Swiper

    var guide_swiper = new Swiper('.swiper-guide .swiper', {
        slidesPerView: 1,
        grabCursor: true,
        speed: 700,
        sticky: true,
        pagination: {
            el: '.swiper-guide .swiper-pagination',
            type: 'bullets',
        },
        navigation: {
            nextEl: '.swiper-guide .swiper-button-next',
            prevEl: '.swiper-guide .swiper-button-prev',
        },
        on: {
            reachEnd: function() {
                // Add the class to the main swiper container when reaching the last slide
                document.querySelector('.swiper-guide .last-button')
                    .classList
                    .add('active');
            },
            slideChange: function() {
                // Check if the new active slide is not the last slide and remove the class
                var swiperContainer = document.querySelector(
                    '.swiper-guide .last-button');
                if (guide_swiper.activeIndex !==
                    guide_swiper.slides.length -
                    1) {
                    swiperContainer.classList.remove('active');
                }
            },
        },
    });

    // Grid Item Image Swiper

    $('.conference-room-gallery-swiper').each(function(index) {
        const swiperId = '.conference-room-gallery-swiper-' + index;
        const paginationId = '.conference-room-gallery-pagination-' + index;
        const nextId = '.conference-room-gallery-next-' + index;
        const prevId = '.conference-room-gallery-prev-' + index;

        // Add data-id attributes to the elements
        $(this).find('.swiper').attr('data-id', swiperId);
        $(this).find('.swiper-pagination').attr('data-id', paginationId);
        $(this).find('.swiper-button-next').attr('data-id', nextId);
        $(this).find('.swiper-button-prev').attr('data-id', prevId);

        // Selectors using the data-id attributes
        const swiperSelector = '[data-id="' + swiperId + '"]';
        const paginationSelector = '[data-id="' + paginationId + '"]';
        const nextSelector = '[data-id="' + nextId + '"]';
        const prevSelector = '[data-id="' + prevId + '"]';

        const conference_room_gallery_swiper = new Swiper(swiperSelector, {
            watchSlidesVisibility: true,
            preloadImages: false,
            lazy: true,
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            speed: 700,
            allowTouchMove: false,
            pagination: {
                el: paginationSelector,
            },
            navigation: {
                nextEl: nextSelector,
                prevEl: prevSelector,
            },
        });
    });
});
